/**
 * Created by stonewang on 2017/8/18.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Table, Popconfirm } from 'antd';
import  EditableCell from './editableCell';

class EditableTable extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      hasSave: false,
      data: props.rows
    };
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ data: nextProps.rows });
  }

  renderColumns (data, index, key, text) {
    const { editable, status, type } = data[index][key];
    if (typeof editable === 'undefined') {
      return text;
    }
    return (<EditableCell
      editable={editable}
      value={text}
      type={type || ''}
      onChange={value => this.handleChange(key, index, value)}
      status={status}
    />);
  }

  handleChange (key, index, value) {
    const { data } = this.state;
    data[index][key].value = value;
    this.setState({ data });
  }

  edit (index) {
    const { data } = this.state;
    Object.keys(data[index]).forEach((item) => {
      if (data[index][item] && typeof data[index][item].editable !== 'undefined') {
        data[index][item].editable = true;
      }
    });
    this.setState({ data });
  }

  deleteOpt (index) {
    this.props.onDelete(index)
  }

  editDone (index, type) {
    const { data } = this.state;
    Object.keys(data[index]).forEach((item) => {
      if (data[index][item] && typeof data[index][item].editable !== 'undefined') {
        data[index][item].editable = false;
        data[index][item].status = type;
      }
    });
    this.setState({ ...this.state, data, hasSave: true }, () => {
      Object.keys(data[index]).forEach((item) => {
        if (data[index][item] && typeof data[index][item].editable !== 'undefined') {
          delete data[index][item].status;
        }
      });
    });
  }

  componentDidUpdate () {
    if (this.state.hasSave) {
      // console.log('Component DID UPDATE!');
      this.props.onEditDone(this.state.data);
      this.setState({ hasSave: false });
    }
  }

  render () {
    const self = this;
    const { data } = this.state;
    const { columns, rowKey, mainKey } = this.props;
    const newColumns = columns.map(item => {
      if (item.title === '操作') {
        item['render'] = (text, record, index) => {
          const { editable } = self.state.data[index][mainKey];
          return (
            <div className="editable-row-operations">
              {
                editable ?
                  <span>
                    <a onClick={() => self.editDone(index, 'save')}>保存</a>
                    <Popconfirm title="确定取消?" onConfirm={() => self.editDone(index, 'cancel')}>
                      <a>取消</a>
                    </Popconfirm>
                  </span> :
                  <span>
                    <a onClick={() => self.edit(index)}>编辑</a>
                    {

                      record.id ? null : <Popconfirm title="确定删除?" onConfirm={() => self.deleteOpt(index)}>
                        <a>删除</a>
                      </Popconfirm>
                    }
                  </span>
              }
            </div>
          );
        }
      }else if(item.title === '序号'){
        item['render'] = (text, record, index) => index+1
      } else {
        item['render'] = (text, record, index) => self.renderColumns(self.state.data, index, item.dataIndex, text)
      }
      return item;
    });
    const dataSource = data.map((item) => {
      const obj = {};
      Object.keys(item).forEach((key) => {
        obj[key] = item[key].hasOwnProperty('value') ? item[key].value : item[key];
      });
      return obj;
    });
    return <Table bordered pagination={false} rowKey={rowKey} dataSource={dataSource} columns={newColumns}/>;
  }
}

EditableTable.propTypes = {
  rowKey: PropTypes.string.isRequired, //一个值唯一的字段
  mainKey: PropTypes.string.isRequired, //一个可编辑的字段的key
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  onEditDone: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
export default EditableTable;


// WEBPACK FOOTER //
// ./src/components/editableTable.js